
import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  OSessionExpiredComponent,
  OAuthService,
} from '@olameter/o-authentication';
import { LicenseManager } from 'ag-grid-enterprise';
import { OConfigService } from '@olameter/o-config-service';
import { OMenuComponent, OMenuItem } from '@olameter/o-menu';
import { UserGRPCService } from './ProxyServices/user.grpc.service';
import { NonSerializedItemsService } from './non-serialized/services/non-serialized.service';
import { NonSerializedInventoryGRPCService } from './ProxyServices/non-serialized-inventory.grpc.service';
import { ViewsService } from './serialized/services/views.service';
import { LanguageService } from './shared/services/language.service';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';


ModuleRegistry.registerModules([AllEnterpriseModule]);

@Component({
  imports: [RouterOutlet, OSessionExpiredComponent, OMenuComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    UserGRPCService,
    NonSerializedItemsService,
    NonSerializedInventoryGRPCService,
    ViewsService
  ]
})
export class AppComponent {
  private configService = inject(OConfigService);
  public authService = inject(OAuthService);
  public clientUser = inject(UserGRPCService);
  public viewsService = inject(ViewsService);
  public availableLanguages: string[] = [];
  public currentLanguage = 'en';

  menu: OMenuItem[] = [];
  environment:string = '';

  constructor(public languageService: LanguageService) {

    effect(() => {
      const user = this.clientUser.user();
      if (user) {
        this.viewsService.get();
      }
    });
  }

  ngOnInit() {
    const config = this.configService.getConfig();

    this.menu = config.menu;
    this.environment = config.environment ?? '';
    this.availableLanguages = this.languageService.getAvailableLanguages();
    this.currentLanguage = this.languageService.getCurrentLanguage();

    const aggrid = config.aggrid;
    const agGridKey = aggrid?.agGridLicenseKey;
    LicenseManager.setLicenseKey(agGridKey);
    
  }

  logout() {
    this.authService.logout();
  }
  onLanguageChange(languageCode: string) {
    this.languageService.setLanguage(languageCode);
    this.currentLanguage = this.languageService.getCurrentLanguage();
  }
}
